export default function isNumberOrHyphenTextField(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
      if(evt.target.selectionStart===0 && evt.target.value.length===0 && (charCode===46 || charCode===43)) {
        return true;
      }
      if(evt.target.selectionStart===0 && evt.target.value.length>0 && evt.target.value.charAt(0)!== '.' && evt.target.value.charAt(0)!== '+' && (charCode===46 || charCode===43)) {
        return true;
      }
      if(evt.target.value.length > 0 && charCode===45 && !evt.target.value.includes('-')) {
        return true;
      }
      evt.preventDefault();
    } else {
      return true;
    }
  }